<template>
  <div>
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——资讯动态</p>

      <div class="content">
        <div class="leftNav">
          <h2>栏目导航</h2>
          <div>
            <ul>
              <router-link to="" ><li :class="{active:activeFlag == 'tongzhi'}" @click="navCur('tongzhi')">通知公告</li></router-link>
              <router-link to="" ><li :class="{active:activeFlag == 'dongtai'}" @click="navCur('dongtai')">馆内动态</li></router-link>
              <router-link to="" ><li :class="{active:activeFlag == 'zhidu'}" @click="navCur('zhidu')">规章制度</li></router-link>
              <router-link to="" ><li :class="{active:activeFlag == 'gongkai'}" @click="navCur('gongkai')">政务公开</li></router-link>
    <!--      <router-link to="" ><li :class="{active:activeFlag == 'duanshipin'}" @click="navCur('duanshipin')">短视频</li></router-link>       -->
            </ul>
          </div>
        </div>
        <div class="rightCol">
          <div class="rightCol-c">
            <h2>
              <span>资讯动态</span>
            </h2>
            <div class="newsList">
              <ul>
                <li v-for="item in newsList" :key="item.index">
                  <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank">
                    {{item.title}}
                    <span>{{item.createTime | dataFormat('yyyy-mm-dd')}}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>


    </div>

    <!--  底部模板  -->
    <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";
import {request} from "@/request/request";

export default {
  name: "NewsListYjj",
  components:{
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{

      activeFlag:'tongzhi',
      restfulUrl:'articles',
      newsList:[]
    }
  },
  methods:{
    navCur(data){
      this.activeFlag = data;
      if(data == 'tongzhi'){
        this.getListByColumn(4)
      }
      if(data == 'dongtai'){
        this.getListByColumn(5)
      }
      if(data == 'video'){
        this.getListByColumn(6)
      }
      if(data == 'zhidu'){
        this.getListByColumn(31)
      }
      if(data == 'gongkai'){
        this.getListByColumn(32)
      }
    },
    getListByColumn(column){
      request({
        method:'POST',
        url:this.restfulUrl+'/getbycolumn',
        data:{columnId:column}
      }).then(res =>{
        this.newsList = res.data;
      },err=>{
        console.log(err)
      })
    }
  },
  mounted() {
    this.getListByColumn(4)
  },
  filters:{
    dataFormat(input,pattern=''){
      var dt = new Date(input);
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, '0');
      var d = dt.getDate().toString().padStart(2, '0');

      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, '0');
        var mm = dt.getMinutes().toString().padStart(2, '0');
        var ss = dt.getSeconds().toString().padStart(2, '0');

        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;

      }

    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>

.container{
  width:70%;
  margin: 0 auto;
  padding:10px 0;
}
.active{
  color:#9E1A28;
  font-weight: bold;
}
.nav{
  text-align: left;
}
.content{
  display: flex;
  margin-top: 20px;
}
.content .leftNav{
  flex:1
}
.leftNav h2{
  color: white;
  height: 60px;
  line-height: 60px;
  background: #9E1A28;
}
.leftNav div{
  margin-top: 10px;
  border: 1px solid silver;
}
.leftNav div{
  padding-bottom: 20px;
}
.leftNav div ul{
  padding:0 20px;
}
.leftNav div ul li {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px silver dashed;
}
.leftNav div ul a{
  color: black;
  text-decoration: none;
}
.rightCol{
  flex: 4;

}
.rightCol-c{
  padding:10px 0 0 60px;
}
.rightCol-c h2{
  padding-bottom: 10px;
  border-bottom: 1px solid silver;
  text-align: left;
}
.rightCol-c h2 span{
  color: #9E1A28;
  padding-bottom: 6px;
  border-bottom: 5px solid #9E1A28;
}
.newsList{
  text-align: left;
  padding:20px;
  min-height: 600px;
}
.newsList li{
  line-height: 50px;
  border-bottom: 1px silver dashed;
}
.newsList a{
  color:black;
  text-decoration: none;
  font-size: 18px;
}
.newsList a span{
  float: right;
}
</style>
